module.exports = __webpack_public_path__ + "static/media/background-618.c0fe65e0.jpg";